import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './Styles/Custom.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Importing the Bootstrap CSS
// import 'bootstrap/dist/css/bootstrap.min.css';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode >,
  document.getElementById('root')
);

